import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Col } from 'react-bootstrap';
import { injectIntl } from 'react-intl';

import { getDefaultImage, getThumbFile } from 'helpers/items';

class YourCar extends React.Component {
  getLink = () => {
    const {
      appIntl: { urlPrefix },
      car,
      link,
    } = this.props;
    return link || urlPrefix + 'account/myCars/' + car.id;
  };

  getFooter = () => {
    const {
      intl: { messages },
      footer,
    } = this.props;

    const link = this.getLink();

    return (
      footer || (
        <ul className="reactions">
          <li>
            <Link to={link}>
              {messages.view} <i class="fad fa-arrow-circle-right" />
            </Link>
          </li>
        </ul>
      )
    );
  };

  render() {
    const { car, colProps } = this.props;

    const link = this.getLink();

    const defaultImage = getDefaultImage(car.item);
    let defaultImageThumb;
    if (defaultImage !== undefined) {
      defaultImageThumb = getThumbFile(defaultImage);
    }

    return (
      <Col {...colProps} className="m-t-20 grid-item">
        <div className="widget-11 card no-margin b-grey b-a">
          <div className="card-header p-t-20 p-l-15">
            <div className="card-title">{car.name}</div>
          </div>
          <div className="card-description p-l-15 p-r-15 p-b-10">
            {car.brand_name} {car.model_name}
          </div>
          {defaultImageThumb !== undefined ? (
            <div className="card-content">
              <Link to={link}>
                <img src={defaultImageThumb.web_link} class="img-responsive" alt={car.name} />
              </Link>
            </div>
          ) : (
            <div className="card-content bg-master-lighter p-t-35 p-b-35 text-center">
              <Link to={link}>
                <i className="fad fa-car fa-4x text-primary" />
              </Link>
            </div>
          )}
          <div className="card-footer clearfix">{this.getFooter()}</div>
        </div>
      </Col>
    );
  }
}
YourCar.defaultProps = {
  colProps: { xs: 12, md: 6, lg: 3 },
};

const mapStateToProps = state => {
  return {
    appIntl: state.intl,
  };
};

export default injectIntl(connect(mapStateToProps)(YourCar));
